/**
 * Gerbang fitur AI di sisi layar — CERMIN PERSIS `backend/ai_akses.py`.
 *
 * KENAPA BERKAS SENDIRI, BUKAN `can("ai_assistant", "view")` LANGSUNG:
 * aturannya bukan sekadar "baca satu kotak centang". Ada LANTAI role
 * (`finance_ceo`/`finance_spv` menyala tanpa dicentang) yang TIDAK ada di
 * `defaultCan()` milik AuthContext — di sana role `finance_*` justru ditolak
 * untuk modul non-finance seperti `ai_assistant`. Kalau tiap halaman menulis
 * `can("ai_assistant","view")` sendiri, CEO Finance akan melihat tombol AI-nya
 * HILANG padahal backend meloloskannya: fiturnya ada tapi tak terlihat, kelas
 * bug yang sudah pernah menggigit di repo ini (lihat komentar `defaultCan`).
 *
 * Aturan yang dicerminkan (urutannya penting, sama seperti backend):
 *   1. Ada centangan eksplisit `permissions.ai_assistant.view` → itu yang menang,
 *      termasuk saat owner MEMATIKANnya untuk akun tertentu.
 *   2. Belum dicentang & role-nya setingkat CEO/SPV finance → menyala.
 *   3. Sisanya ikut `can()` biasa (superadmin/admin/viewer lolos di sana).
 *
 * Kalau `backend/ai_akses.py` berubah, berkas ini WAJIB ikut berubah —
 * `backend/tests/test_gerbang_fitur_ai.py` menjaga keduanya tetap sejalan.
 */
export const KUNCI_IZIN_AI = "ai_assistant";
export const AKSI_IZIN_AI = "view";
export const ROLE_BAWAAN_BOLEH_AI = ["finance_ceo", "finance_spv"];

export function bolehPakaiAI(user, can) {
  if (!user || typeof can !== "function") return false;
  const baris = (user.permissions || {})[KUNCI_IZIN_AI];
  if (baris && typeof baris === "object"
      && Object.prototype.hasOwnProperty.call(baris, AKSI_IZIN_AI)) {
    // Lewat `can()`, bukan membaca nilainya mentah — supaya izin berjangka
    // waktu (`expires`) tetap dihormati tanpa disalin ulang di sini.
    return !!can(KUNCI_IZIN_AI, AKSI_IZIN_AI);
  }
  if (ROLE_BAWAAN_BOLEH_AI.includes(user.role)) return true;
  return !!can(KUNCI_IZIN_AI, AKSI_IZIN_AI);
}
